import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const SuperpositionMaxPower = () => (
  <QPhototModuleSubtopic
    title="Super position and Maximum power transformation"
    videos={[
      "https://www.youtube.com/embed/ZJ8zD8m-B1Q",
      "https://www.youtube.com/embed/y0-Bc4YfdaQ",
      "https://www.youtube.com/embed/U85eA3-suiQ",
      "https://www.youtube.com/embed/bt_D-ACTC4w"
    ]}
    takeaways={[
      { text: "Practice as many as problems from this topics." },
      { text: "Expected a question from this topic." }
    ]}
    questions={[
      { image: "/beee_12.jpeg" },
      { image: "/beee_13.jpeg" },
      { image: "/beee_14.jpeg" }
    ]}
    exampleVideos={[]}
  />
);

export default SuperpositionMaxPower;
